/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { PropertyFeatures } from '@zcode/enums'
import type { Listable, Pin, Property } from '@zcode/state-type'

export const isMilitaryHousingFeature = (t: Listable | Pin | Property) =>
  t.features?.includes(PropertyFeatures.MILITARY_HOUSING)
